import { t } from "@lingui/macro"
import { FormControl, FormHelperText, Stack } from "@mui/material"
import { observer } from "mobx-react"
import { useCallback } from "react"

import { TagsComponent } from "src/components/Tags"
import { KnowledgeItemStore } from "src/modals/knowledge-items/store"
import { useStore } from "src/store/lib/useStore"
import { ITag } from "src/types/tags/tag"

export const KnowledgeItemsTags = observer(() => {
    const store = useStore(KnowledgeItemStore)

    const handleTagsChange = useCallback(
        (tags: ITag[]) => {
            store.formFields.set(
                "tags",
                tags.map((tag) => tag.id),
            )
        },
        [store.formFields],
    )

    return (
        <FormControl style={{ breakInside: "avoid", marginTop: "-0px" }}>
            <Stack spacing={0}>
                <TagsComponent
                    id="knowledge-item-tags"
                    onChange={handleTagsChange}
                    tagIds={store.formFields.get("tags")}
                />
            </Stack>
            <FormHelperText error={false}>
                {t`knowledge-item-modal.tags.optional`}
            </FormHelperText>
        </FormControl>
    )
})
